export default [
  {
    path: '/apps/alcada/list',
    name: 'apps-alcada-list',
    component: () => import('@/views/cadastros/apoio-vendas/alcada/list/Index.vue'),
    meta: {
      pageTitle: 'Alçada',
    },
  },
  // {
  //     path: '/apps/alcada/edit/:id',
  //     name: 'apps-alcada-edit',
  //     component: () => import('@/views/cadastros/apoio-vendas/alcada/alcada-edit/Pic RegraEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Pic Regra',
  //     },
  // },
];
